// extracted by mini-css-extract-plugin
export default {"modalContent":"SendOrderForPaymentModal_modalContent__Fy508"};